exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    list-style: none;\n    padding: 8px;\n    border-bottom: 4px solid #091a1a;\n    margin: 0;\n    background-color: #FFE000;\n}\n\nli {\n    width: 20%;\n    line-height: 20px;\n    text-align: center;\n}\n\nli a {\n    color: black;\n    text-decoration: underline;\n    font-size: 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main